import { SeminarContentType } from '@/services/seminars';
import * as Styles from './SeminarOverview.styles';

export type SeminarOverviewProps = Pick<SeminarContentType, 'description'>;

const SeminarOverview = ({ description }: SeminarOverviewProps): JSX.Element => {
  return (
    <div>
      <Styles.DescriptionSubTitle data-testid="seminar-details-overview">
        Overview
      </Styles.DescriptionSubTitle>
      <Styles.DescriptionText data-testid="seminar-details-description">
        {description}
      </Styles.DescriptionText>
    </div>
  );
};

export default SeminarOverview;
